import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import '../components/upiid-details/solicitation-upiid-details.scss';

import UpiidDetailsProvider from '../components/upiid-details/upiid-details-provider';
import RenewSolicitationContent from './renew-solicitation-content';
import { breadcrumbsPath } from '../utils/solicitation-helpers';

const RenewSolicitation = () => {
  return (
    <>
      <Breadcrumbs current="Renew Solicitation" path={breadcrumbsPath} />
      <UpiidDetailsProvider>
        <RenewSolicitationContent />
      </UpiidDetailsProvider>
    </>
  );
};

export default RenewSolicitation;
